module.exports = __webpack_public_path__ + "static/img/方太VP10.6223c8c3.png";